
import urlFile from "../common/ApiFile"
import url from "../common/api"
import {addQueries} from "../queries/addQueries.js"
import {updateRessource} from "./ressourceService"
import axios from 'axios'


export async function postFile(link,param){
    var count={}
    
    await addQueries(url+link,param).then(elem=>{
     count =   elem
       
    })
   return await count;
    
}


export async function postPjointeToLocalStorage(){
  var count={}
  var param=document.getElementById("pieceJointe").files
  var pjointe=[]
  for (var i=0;i<param.length;i++){
    var formData = new FormData(); 
    // Update the formData object 
    formData.append( 
      "avatar", 
      param[i] 
    );

    await addQueries(urlFile.file+"/fileupload.php",formData).then(elem=>{
      const response =   elem.data
      postFile("pjointes",{"file":response.name,"taille":response.size}).then(response=>{
        pjointe= [...pjointe,{"pjointe_id":response.id}]
      })
      if(i==param.length-1){
          return  pjointe
      }
    })
  }
}

export async function updatePjointe(formData){


    await addQueries(urlFile.file+"/fileupload.php",formData).then(elem=>{
      const response =   elem

      postFile("pjointes",{"file":response.name,"taille":response.size}).then(data=>{
          
        updateRessource({"ressource_pjointes_attributes":[{"pjointe_id":data.id}]}).then(data=>{

        })
      })
      
    })
  
}

export async function updateImage(formData){
 
    await addQueries(urlFile.file+"/fileupload.php",formData).then(elem=>{
      const response =   elem
 
      postFile("images",{"file":response.name,"taille":response.size}).then(response=>{
    
          
        updateRessource({"ressource_imgs_attributes":[{"image_id":response.id}]}).then(data=>{
     
          
        })
      })
      
    })
  
}

export async function postImageToLocalStorage(){
    var count={}
    var param=document.getElementById("image").files
    var image=[]

  for (var i=0;i<param.length;i++){

    var formData = new FormData(); 
        
    // Update the formData object 
    formData.append( 
      "avatar", 
      param[i] 
    
    );


    await addQueries(urlFile.image+"/fileupload.php",formData).then(elem=>{
     const response =   elem.data
 
      postFile("images",{"file":response.name,"taille":response.size}).then(response=>{
          image= [...image,{"image_id":response.data.id}]
        
        if(i==param.length-1){
          return image
        }
       
      })

    })

}
}